module.exports = __webpack_public_path__ + "static/neil-gaiman-697d76310f26be6ad93cace260ed8d34.jpg";